import type { ThemeOptions } from '@mui/material/styles'

import TablePaginationActions from '@/components/UI/Table/PaginationActions'

import { colours, fonts, radii, scrollbar } from './tokens'

export const components: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        fontSize: 14,
        // Don't turn antialiasing on for everything by default; use it only on selected elements.
        WebkitFontSmoothing: 'auto',
      },
      body: {
        fontFamily: fonts.body,
        color: colours.blue,
        fontSize: 14,
      },
      'h1, h2': {
        fontFamily: fonts.heading,
      },
      '*::-webkit-scrollbar-track': {
        WebkitBoxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.2)',
        backgroundColor: scrollbar.track,
        borderRadius: radii.scrollbar,
      },
      '*::-webkit-scrollbar': {
        width: scrollbar.width,
        backgroundColor: scrollbar.track,
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: scrollbar.thumb,
        borderRadius: radii.scrollbar,
        border: `1px solid ${scrollbar.thumbBorder}`,
      },
      '@media print': {
        body: {
          WebkitPrintColorAdjust: 'exact',
          printColorAdjust: 'exact',
        },
        'body .menu-drawer': {
          display: 'none',
        },
      },
    },
  },
  MuiAppBar: {
    defaultProps: {
      position: 'fixed',
      elevation: 1,
      variant: 'elevation',
    },
  },
  MuiPaper: {
    defaultProps: {
      square: true,
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        'th:first-child': { paddingLeft: 0 },
        'th:last-child': { paddingRight: 0 },
      },
    },
  },
  MuiSkeleton: {
    defaultProps: {
      animation: 'pulse',
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        // workaround for a bug in the library where icons and text do not align inside the button
        lineHeight: 0,
        // Restore MUI's default after the icon alignment workaround can be removed.
        // lineHeight: 1.75,
      },
    },
  },
  MuiTablePagination: {
    defaultProps: {
      labelDisplayedRows: ({ from, to, count }) =>
        count === 0 ? '' : `${from}-${to} of ${count}`,
      ActionsComponent: TablePaginationActions,
      sx: { border: 0 },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.info.main,
      }),
    },
  },
}
